import type { AxiosError } from 'axios';

const AUTHORIZATION_FAILURE_STATUSES = new Set([401, 403]);
const DEFAULT_RETRY_COUNT = 3;

const shouldRetryApiQuery = (failureCount: number, error: unknown) => {
  const status = (error as AxiosError | undefined)?.response?.status;

  return (
    !AUTHORIZATION_FAILURE_STATUSES.has(status ?? 0) &&
    failureCount < DEFAULT_RETRY_COUNT
  );
};

export default shouldRetryApiQuery;
